// extracted by mini-css-extract-plugin
export var OverviewTable = "Overview-module--OverviewTable--1-zEi";
export var div = "Overview-module--div--20V_K";
export var dt = "Overview-module--dt--1JK5U";
export var dd = "Overview-module--dd--2GEa7";